import OrgSettingsCell from "src/components/OrgSettingsTeamCell/OrgSettingsTeamCell"
import { MetaTags } from '@redwoodjs/web'

const OrgSettingsTeamPage = () => {
  return (
    <>
      <MetaTags title="Settings" description="Company Settings" />
      <OrgSettingsCell/>
    </>
  )
}

export default OrgSettingsTeamPage
